//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Spondyloarthropathies",
  data() {
    return {
      form: {
        value1: "0",
        value2: "0",
        value3: "0",
        value4: "0",
        value5: "0",
        value6: "0",
        value7: "0",
        value8: "0",
        value9: "0",
        value10: "0",
        value11: "0",
        value12: "0",
        value13: "0",
      },
      hasScore: false,
      disabled: false,
     
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "0";
      } else {
        // chf+mi+periphVasc+cerebroVasc+pulmonary+liver+ulcer+dm+renal*2+tumor*2+metastatic*6+leukemia*2+lymphoma*2+aids*6+tissue+dementia+hemiplegia*2
        let result =
          form.value1 +
          form.value2 * 2 +
          form.value3 +
          form.value4 * 2 +
          form.value5 * 2 +
          form.value6 * 2 +
          form.value7 * 2 +
          form.value8 +
          form.value9+
          form.value10 +
          form.value11 * 3 +
          form.value12 * 3 +
          form.value13 * 2 
         

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Spondyloarthropathies.vue